module.exports = __webpack_public_path__ + "img/img1.91e0ddce.png";